<!--
대금상환 창고지급 팝업 (TASK-161 §0-9 · §3-3 「대금상환 센터」 — 라운드 ⓒ · 라벨 결정 30 · 날짜 결정 28)
------------------------------------
 - 페이지당 1 인스턴스. 행 「창고지급」 버튼이 open(row) 로 데이터 주입 (row = page.cod_rows[id])
 - 사이클 14 #13: 오더번호 · 트래킹 · 대금상환금액 아래 소속 상품 카드 (공용 app-buy-order-prod-cards readonly — row.prods, .cdp-popup-prod-card)
 - 사이클 16 #27: 상단 = 공용 컨텍스트 헤더 app-buy-order-ctx (대금상환금액 큰 글자) · 상품 = 간략 행 (트래킹은 헤더로 — TASK-172 절 D: 1.4rem 굵게 + 복사)
 - TASK-172 결정 v2-④: 본문 = 영역 구분선 (상품 · 지급 입력 · 버튼 사이 1px 선 + 캡션 「지급 입력」 · 입력 영역 옅은 바탕 · 입력칸 테두리 진하게 — buy-order-card.scss .cdp-paid-popup)
   E2E 셀렉터 보존 = .cdp-popup-prods__hd (「소속 상품 N건」) · .cdp-paid-amount · .cdp-paid-at · .cdp-paid-memo · .cdp-paid-submit
 - 창고지급(실제) 기본 = 대금상환금액 · 창고지급일 기본 = 오늘 · 창고지급비고 (기존값 프리필 — 결정 4) · 오더번호/트래킹 표시
 - 창고지급일 = flatpickr (Y-m-d, 직접 입력 가능 — date-input.js)
 - 저장 → PATCH /regions/{regionId}/cod-payments/{id}/paid (0원 거부 문구 = 서버 Logic 그대로)
 - 성공 = 서버 msg alert 후 새로고침
-->
<template>
    <div ref="modal" uk-modal esc-close="false" bg-close="false" class="cdp-popup cdp-paid-popup">
        <div class="uk-modal-dialog uk-modal-body uk-text-left">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <h3 class="uk-modal-title">대금상환 창고지급</h3>

            <!-- 사이클 16 #27 — 컨텍스트 헤더 (공용 app-buy-order-ctx: 해외오더번호 · 트래킹 칩 · 대금상환금액 큰 글자) -->
            <app-buy-order-ctx v-if="row" :code="row.buy_order_code || ''" :trackings="row.tracking_nos || []"
                               :items="[{k: '대금상환금액', v: reqAmountText, big: true}]"></app-buy-order-ctx>

            <!-- 사이클 14 #13 → 16 #27 — 소속 상품 간략 행 (공용 app-buy-order-prod-cards readonly · 데이터 = page.cod_rows[id].prods, 추가 조회 0 · 스크롤 = 목록 안)
                 TASK-172 결정 v2-④ — 본문 영역 구분선 (상품 · 지급 입력 · 버튼 사이 1px 선 + 영역 캡션, buy-order-card.scss .cdp-paid-popup) -->
            <div class="cdp-paid-sec cdp-popup-prods" v-if="row && row.prods">
                <div class="uk-text-muted cdp-popup-prods__hd">소속 상품 {{ row.prods.length }}건</div>
                <div class="cdp-popup-prods__wrap">
                    <app-buy-order-prod-cards :prods="row.prods" readonly card-class="cdp-popup-prod-card"></app-buy-order-prod-cards>
                </div>
            </div>

            <!-- 지급 입력 영역 (라벨 왼쪽 · 입력 오른쪽 · 옅은 바탕 · 테두리 진하게) -->
            <div class="cdp-paid-sec cdp-paid-form">
                <div class="cdp-paid-cap">지급 입력</div>

                <div class="cdp-paid-row">
                    <label class="uk-form-label">창고지급(실제) <span v-if="row && row.currency">({{ row.currency }})</span></label>
                    <div class="uk-form-controls">
                        <input class="uk-input cdp-paid-amount" type="text" v-model.trim="inputPaidAmount" placeholder="창고지급(실제)"/>
                    </div>
                </div>

                <div class="cdp-paid-row">
                    <label class="uk-form-label">창고지급일</label>
                    <div class="uk-form-controls">
                        <input ref="paidAt" class="uk-input cdp-paid-at" type="text" v-model="inputPaidAt" placeholder="e.g. 2025-01-01"/>
                    </div>
                </div>

                <div class="cdp-paid-row">
                    <label class="uk-form-label">창고지급비고</label>
                    <div class="uk-form-controls">
                        <textarea class="uk-textarea cdp-paid-memo" rows="3" v-model="inputPaidMemo" placeholder="창고지급비고 (선택)"></textarea>
                    </div>
                </div>
            </div>

            <div class="cdp-paid-sec cdp-paid-actions uk-text-right">
                <button class="uk-button uk-button-default uk-modal-close" type="button">닫기</button>
                <button class="uk-button uk-button-primary cdp-paid-submit" type="button" :disabled="busy" @click="submit">창고지급</button>
            </div>
        </div>
    </div>
</template>

<script>
    import CodPopupMixin from './popup-mixin';
    import { bindDateInput, setDateInput, destroyDateInput } from './date-input';

    export default {
        mixins: [CodPopupMixin],
        props: {
            // csrf-token
            csrfToken: String,

            // 센터ID (라우트)
            regionId: [String, Number],
        },
        data: function () {
            return {
                inputPaidAmount: '',
                inputPaidAt: '',
                inputPaidMemo: '',
            };
        },
        created() {
            // flatpickr instance (비반응)
            this.paidAtPicker = null;
        },
        mounted() {
            // 결정 28 — 날짜 포맷 Y-m-d (flatpickr)
            this.paidAtPicker = bindDateInput(this.$refs.paidAt, (value) => {
                this.inputPaidAt = value;
            });
        },
        beforeDestroy() {
            destroyDateInput(this.paidAtPicker);
            this.paidAtPicker = null;
        },
        methods: {
            open(row) {
                this.row = row || null;
                this.inputPaidAmount = row ? this.normalize(row.req_amount) : '';
                this.inputPaidAt = this.today();
                setDateInput(this.paidAtPicker, this.inputPaidAt);
                // 결정 4 — 창고지급취소 후 재지급이면 유지된 기존 창고지급비고를 프리필
                this.inputPaidMemo = row ? this.normalize(row.paid_memo) : '';
                this.show();
            },

            submit() {
                if (this.busy || ! this.row) {
                    return;
                }
                this.request('patch', '/regions/' + this.regionId + '/cod-payments/' + this.row.id + '/paid', {
                    paid_amount: this.inputPaidAmount,
                    paid_at: this.inputPaidAt,
                    paid_memo: this.inputPaidMemo,
                }).then(this.done);
            },
        },
    }
</script>

<style lang="scss" scoped>
    // 소속 상품 (사이클 14 #13 → 16 #27) — 높이 제한 · 스크롤 = 공용 목록 안 (머리글 + 6행, 입력란은 고정)
    .cdp-popup-prods__hd {
        margin-bottom: 4px;
    }
</style>
